<template>
  <div
    v-if="modalIsOpened"
    id="teamInfoModal"
    class="fixed inset-0 w-full bg-black/30 z-51"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
      @click.self="closeModal"
    >
      <div
        class="w-[100vw] max-w-[1084px] min-h-[690px] max-h-[690px] px-[20px] overflow-hidden m-auto"
      >
        <!-- actual modal -->
        <div
          class="h-full mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div
            class="flex flex-col justify-center items-start gap-[22px] p-[20px] pt-[12px]"
          >
            <div class="w-full h-[74px] flex flex-col items-center relative">
              <WorkFlowChartIcon class="w-[50px] h-[50px] text-[#9B237B]" />
              <span class="PC_Body1-SB text-[#1F1D1F]">ระบบบัญชาการ</span>
              <div
                class="absolute right-0 border border-grey-light rounded-md w-9 h-9 flex items-center justify-center cursor-pointer"
                @click="closeModal"
              >
                <CloseIcon class="w-9 text-primary" />
              </div>
            </div>
            <!-- Organization chart -->

            <OrgChart :img="headImg" @clicked="info" />

            <!-- Organization chart -->
            <div class="w-full h-[1px] bg-[#B7B2B5]"></div>
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'ปิดหน้าต่าง'"
                :bClass="'btn_shadow--cancel !max-w-[150px]'"
                @clicked="closeModal"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import OrgChart from "@/components/Utilities/OrgChart.vue";

const props = defineProps({
  headImg: {
    type: Object,
    default: [],
  },
});

const emit = defineEmits(["headInfo", "info"]);

const item = ref({});
const modalIsOpened = ref(false);

const openModal = (data) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
  item.value = data;
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const info = async (id, name) => {
  if (id === "1") {
    emit("headInfo", props.headImg, name);
  } else {
    emit("info", id, name);
  }
};

defineExpose({ openModal, closeModal });
</script>

<style lang="scss" scoped>
</style>